<main>
  <!-- ── S1: Hero ── -->
  <section class="community-section community-section--alt community-hero">
    <div class="prose-container community-hero__inner">
      <h1 class="community-hero__title">{{ data.hero.title }}</h1>
      <p class="community-hero__subtitle">{{ data.hero.subtitle }}</p>
      <!-- El enlace suelto que vivía aquí se ha movido bajo la tira de eventos
           (S1.5): los eventos son lo único real de esta página, así que se ven
           en vez de anunciarse. El enlace se conserva verbatim. -->
      @if (!mascotError()) {
        <div class="community-hero__mascot">
          <img
            [src]="data.hero.mascotImage"
            [alt]="data.hero.mascotAlt"
            class="community-hero__mascot-img"
            loading="lazy"
            (error)="onMascotError()"
          />
        </div>
      }
    </div>
  </section>

  <!-- ── S1.5: Próximos eventos ──
       Esta sección NO puede ocultarse en vacío: sustituye al enlace del hero,
       y esconderla se llevaría también el enlace, que es lo que había antes.
       Por eso es el único de los tres bloques de comunidad con estado vacío
       visible — corgi, copy y el enlace intacto. -->
  <section class="community-section community-events">
    <div class="community-grid" aos="fade-up">
      <header class="community-section__header">
        <h2 class="community-section__title community-section__title--centered">
          {{ eventsCopy.upcomingTitle }}
        </h2>
      </header>

      @if (events().length > 0) {
        <div class="community-events__list">
          <!-- Lista global: aquí el chip sí identifica el juego. -->
          @for (event of events(); track event.id) {
            <app-event-card [event]="event" [showGame]="true" />
          }
        </div>
      } @else {
        <div class="community-events__empty">
          @if (!eventsMascotError()) {
            <img
              src="images/logo/comunity.png"
              alt="Mascota Perrón esperando el próximo evento"
              class="community-events__empty-mascot"
              loading="lazy"
              (error)="onEventsMascotError()"
            />
          }
          <p class="community-events__empty-text">{{ eventsCopy.communityEmpty }}</p>
        </div>
      }

      <div class="community-events__footer">
        <a class="community-events__link" routerLink="/eventos">
          {{ eventsCopy.communityCalendarLink }}
        </a>
      </div>
    </div>
  </section>

  <!-- ── S2: Redes Sociales ── -->
  <section class="community-section">
    <div class="community-grid" aos="fade-up">
      <header class="community-section__header">
        <h2 class="community-section__title community-section__title--centered">
          {{ data.social.title }}
        </h2>
        <p class="community-section__subtitle">{{ data.social.subtitle }}</p>
      </header>

      <a
        class="community-social__hero"
        [href]="data.social.whatsapp.url"
        target="_blank"
        rel="noopener noreferrer"
        [attr.aria-label]="data.social.whatsapp.name"
      >
        <div class="community-social__hero-icon">
          <app-icon [icon]="whatsappIcon" [size]="32" />
        </div>
        <div class="community-social__hero-body">
          <h3 class="community-social__hero-title">{{ data.social.whatsapp.name }}</h3>
          <p class="community-social__hero-desc">{{ data.social.whatsapp.description }}</p>
          <span class="community-social__hero-handle">{{ data.social.whatsapp.handle }}</span>
        </div>
        <span class="community-social__hero-cta">{{ data.social.whatsapp.cta }}</span>
      </a>

      <div class="community-social__grid">
        @for (channel of data.social.channels; track channel.id) {
          <a
            class="community-social__card"
            [class]="'community-social__card--' + channel.platform"
            [href]="channel.url"
            target="_blank"
            rel="noopener noreferrer"
            [attr.aria-label]="channel.name"
          >
            <div class="community-social__card-icon">
              <app-icon [icon]="channelIcons[channel.platform]" [size]="24" />
            </div>
            <div class="community-social__card-body">
              <span class="community-social__card-name">{{ channel.name }}</span>
              <span class="community-social__card-desc">{{ channel.description }}</span>
              <span class="community-social__card-handle">{{ channel.handle }}</span>
            </div>
            <span class="community-social__card-cta">{{ channel.cta }}</span>
          </a>
        }
      </div>
    </div>
  </section>

  <!-- ── S3: ¿Con quién jugar? ──
       Directorio real de jugadores (B11 J1), solo con sesión verificada. La cabecera
       se pinta en el SSR; los datos, nunca (B30): la sección arranca en skeleton. -->
  <section class="community-section community-section--alt">
    <!-- `aos` solo en la cabecera: `[data-aos]` deja `transform` + `will-change`, que convierten
         el contenedor en el bloque de referencia de los `position: fixed` hijos y encerrarían
         el modal «Invitar a jugar» (y su z-index) en la caja de la sección (B11 J3). -->
    <div class="community-grid">
      <header class="community-section__header" aos="fade-up">
        <h2 class="community-section__title community-section__title--centered">
          {{ data.playerFinder.title }}
        </h2>
        <p class="community-section__subtitle">{{ data.playerFinder.subtitle }}</p>
      </header>

      <app-player-finder />
    </div>
  </section>

  <!-- ── S4: Blog ── -->
  <!-- <section class="community-section">
    <div class="community-grid" aos="fade-up">
      <header class="community-section__header">
        <h2 class="community-section__title community-section__title--centered">
          {{ data.blog.title }}
        </h2>
        <p class="community-section__subtitle">{{ data.blog.subtitle }}</p>
      </header>

      <div class="community-blog__grid">
        @for (card of data.blog.cards; track card.title) {
          <article class="community-blog__card">
            <a [routerLink]="card.url" class="community-blog__card-link">
              <div class="community-blog__image-wrap">
                <img
                  [src]="card.image"
                  [alt]="card.title"
                  class="community-blog__image"
                  loading="lazy"
                />
                <span
                  class="community-blog__category"
                  [style.--category-color]="card.categoryColor"
                >
                  {{ card.category }}
                </span>
              </div>
              <div class="community-blog__body">
                <time class="community-blog__date">{{ card.date }}</time>
                <h3 class="community-blog__title">{{ card.title }}</h3>
                <p class="community-blog__excerpt">{{ card.excerpt }}</p>
              </div>
            </a>
          </article>
        }
      </div>

      <div class="community-blog__footer">
        <a [routerLink]="data.blog.cta.url" class="community-blog__all">
          {{ data.blog.cta.label }}
        </a>
      </div>
    </div>
  </section> -->

  <!-- ── S5: Newsletter ── -->
  <section class="community-section">
    <div class="prose-container community-newsletter" aos="fade-up">
      <header class="community-section__header community-section__header--center">
        <h2 class="community-section__title community-section__title--centered">
          {{ data.newsletter.title }}
        </h2>
        <p class="community-section__subtitle">{{ data.newsletter.subtitle }}</p>
      </header>
      <app-newsletter-form
        class="community-newsletter__form"
        variant="inline"
        inputId="community-newsletter-email"
        [placeholder]="data.newsletter.placeholder"
        [ctaLabel]="data.newsletter.buttonLabel"
      />
    </div>
  </section>

  <!-- ── S6: Stats ── -->
  <section class="community-section community-section--alt">
    <div class="community-grid" aos="fade-up">
      <header class="community-section__header">
        <h2 class="community-section__title community-section__title--centered">
          {{ data.stats.title }}
        </h2>
      </header>
      <div class="community-stats__grid">
        @for (stat of data.stats.items; track stat.label) {
          <div class="community-stats__item">
            <div class="community-stats__value" [countUp]="stat.value"></div>
            <div class="community-stats__label">{{ stat.label }}</div>
          </div>
        }
      </div>
    </div>
  </section>

  <!-- ── S7: CTA cierre ── -->
  <section class="community-section community-cta" aos="fade-up">
    <div class="community-grid community-cta__inner">
      <h2 class="community-cta__title">{{ data.cta.title }}</h2>
      <p class="community-cta__subtitle">{{ data.cta.subtitle }}</p>
      <button type="button" (click)="openRegister()" class="community-cta__button">
        {{ data.cta.buttonLabel }}
      </button>
      <div class="community-cta__social">
        <a
          [href]="data.social.whatsapp.url"
          target="_blank"
          rel="noopener noreferrer"
          class="community-cta__social-link"
          aria-label="WhatsApp"
        >
          <app-icon [icon]="whatsappIcon" [size]="20" />
        </a>
        @for (channel of data.social.channels; track channel.id) {
          <a
            [href]="channel.url"
            target="_blank"
            rel="noopener noreferrer"
            class="community-cta__social-link"
            [attr.aria-label]="channel.name"
          >
            <app-icon [icon]="channelIcons[channel.platform]" [size]="20" />
          </a>
        }
      </div>
    </div>
  </section>
</main>
